export default {
	data: function() {
		return {
			id: null,
			star_rating: new Array(5)
		}
	},
	props: ['rating'],
	watch: {
		rating: function(new_val, old_val) {
			if (new_val) {
				console.log(new_val);
				this.initRating();
			}
		}
	},
	mounted: function() {
		this.id = this._uid;
		this.initRating();
	},
	methods: {
		initRating: function() {
			this.star_rating.fill("0");
			for(var i=0; i<parseInt(this.rating); i++) {
				this.star_rating[i] = "1";
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/common/StarRating/star-rating.js